import { render, staticRenderFns } from "./app-header-notification.vue?vue&type=template&id=3c452cab&"
import script from "./app-header-notification.vue?vue&type=script&lang=ts&"
export * from "./app-header-notification.vue?vue&type=script&lang=ts&"
import style0 from "./app-header-notification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports